module.exports = __webpack_public_path__ + "assets/img/scene2.6c443623.png";